import types from '@constants/action-types';
import { reducerFactory } from '@factories';
import {
  USER_GET_REQUEST,
  USER_GET_SUCCESS,
  USER_GET_FAILURE,
  CREATE_USER_REQUEST,
  CREATE_USER_SUCCESS,
  CREATE_USER_FAILURE,
  GET_USER_ACCOUNT,
  GET_USER_ACCOUNT_SUCCESS,
  CHANGE_PASSWORD_REQUEST,
  CHANGE_SETTINGS_PASSWORD_REQUEST,
  CHANGE_SETTINGS_PASSWORD_SUCCESS,
  CHANGE_SETTINGS_PASSWORD_FAILURE,
  RESET_SETTINGS_PASSWORD,
  VERIFY_CHANGE_PASSWORD_REQUEST,
  INVITE_USER_REQUEST,
  INVITE_USER_SUCCESS,
  INVITE_USER_FAILURE,
  RESET_INVITE_USER_REQUEST,
  UNREAD_MESSAGE_COUNT_SUCCESS,
} from '@store/user/user.const';

export const initialState = {
  id: null,
  email: null,
  initials: null,
  firstName: null,
  lastName: null,
  token: null,
  language: null,
  isLoggingIn: false,
  isLanguageChanging: false,
  isCreatingUser: false,
  hasCreatedUser: false,
  hasInvitedUser: false,
  userInvitationValid: false,
  invitedUser: {},
  hasChangedPassword: false,
  successMessage: null,
  isActive: false,
  isAuthenticated: false,
  error: null,
  currentOrganization: null,
  orgs: {},
  isLoading: false,
  timeout: null,
  refreshExpirationDays: null,
  needs2faSetup: false,
  passwordChange: false,
  account: {},
  changePassword: {},
  verifyChangePassword: {},
  unreadMessageCount: 0,
};
export default reducerFactory(initialState, {
  [USER_GET_REQUEST]: state => ({
    ...state,
    isLoggingIn: true,
    error: null,
  }),
  [USER_GET_FAILURE]: (state, { payload }) => ({
    ...state,
    isLoggingIn: false,
    isAuthenticated: false,
    error: payload,
  }),
  [USER_GET_SUCCESS]: (state, { payload }) => ({
    ...state,
    isLoggingIn: false,
    isAuthenticated: true,
    isLoading: false,
    error: null,
    ...payload,
  }),
  [CREATE_USER_REQUEST]: state => ({
    ...state,
    isCreatingUser: true,
    hasCreatedUser: false,
  }),
  [CREATE_USER_SUCCESS]: (state, { response }) => ({
    ...state,
    isCreatingUser: false,
    hasCreatedUser: true,
    error: '',
    ...response.user,
    token: response.token,
  }),
  [CREATE_USER_FAILURE]: (state, { response }) => ({
    ...state,
    isCreatingUser: false,
    error: response.error,
  }),
  [types.CREATE_ACCOUNT_SUCCESS]: (state, { response }) => ({
    ...state,
    account: response?.user,
  }),
  [GET_USER_ACCOUNT]: state => ({
    ...state,
    isLoading: true,
    hasUserAccount: false,
  }),
  [GET_USER_ACCOUNT_SUCCESS]: (state, { response }) => ({
    ...state,
    isLoading: false,
    hasUserAccount: true,
    ...response,
  }),
  [CHANGE_PASSWORD_REQUEST]: (state, response) => ({
    ...state,
    isLoading: false,
    error: null,
    ...response,
  }),
  [VERIFY_CHANGE_PASSWORD_REQUEST]: (state, response) => ({
    ...state,
    isLoading: false,
    error: null,
    ...response,
  }),
  [CHANGE_SETTINGS_PASSWORD_REQUEST]: (state, response) => ({
    ...state,
    isLoading: true,
    hasChangedPassword: false,
    error: null,
    ...response,
  }),
  [CHANGE_SETTINGS_PASSWORD_SUCCESS]: (state, { response: { response } }) => ({
    ...state,
    isLoading: false,
    error: undefined,
    hasChangedPassword: true,
    successMessage: response.message,
  }),
  [CHANGE_SETTINGS_PASSWORD_FAILURE]: (state, action) => ({
    ...state,
    isLoading: false,
    error: action.response.error,
    hasChangedPassword: false,
    successMessage: null,
  }),
  [RESET_SETTINGS_PASSWORD]: state => ({
    ...state,
    error: null,
    hasChangedPassword: false,
    successMessage: null,
  }),
  [INVITE_USER_REQUEST]: state => ({
    ...state,
    isLoading: true,
    error: null,
  }),
  [INVITE_USER_SUCCESS]: (state, { response: { response } }) => ({
    ...state,
    isLoading: false,
    hasInvitedUser: true,
    invitedUser: response,
  }),
  [INVITE_USER_FAILURE]: (state, action) => ({
    ...state,
    isLoading: false,
    error: action.response.error,
  }),
  [RESET_INVITE_USER_REQUEST]: state => ({
    ...state,
    isLoading: false,
    hasInvitedUser: false,
    error: null,
  }),
  [UNREAD_MESSAGE_COUNT_SUCCESS]: (state, { payload }) => ({
    ...state,
    unreadMessageCount: payload,
  }),
});
